import type {
  AnnualConst,
  CalcOptions,
  TechnologyDatum,
} from "../algorithm.types";

type CalculateAnnualCostsParams = {
  technologyData: ReadonlyArray<
    Pick<TechnologyDatum, "runCost" | "fixCost" | "capStart" | "capEx">
  >;
  annualConst: Pick<AnnualConst, "annualTechCost" | "annualTechGen">;
  sliderValues: Array<number>;
  calcOptions: Pick<CalcOptions, "noOfTechs">;
};

export default function calculateAnnualCosts({
  technologyData,
  annualConst,
  sliderValues,
  calcOptions,
}: CalculateAnnualCostsParams): Array<number> {
  // Annual Cost for each technology (£M) = Annual Tech Generation (TWh) x Running Cost (£/MWh) + Capacity (GW) x [Fixed Cost (£/kW/yr) + Capex (£/kW/yr) ]
  const { annualTechCost, annualTechGen } = annualConst;

  for (let i = 0; i < calcOptions.noOfTechs; i++) {
    annualTechCost[i] =
      annualTechGen[i] * technologyData[i].runCost +
      sliderValues[i] * technologyData[i].fixCost +
      Math.max(0, sliderValues[i] - technologyData[i].capStart) *
        technologyData[i].capEx;
  }
  return annualTechCost;
}
